import { render } from "./ColorEdit.vue?vue&type=template&id=94a422c8&ts=true"
import script from "./ColorEdit.vue?vue&type=script&lang=ts"
export * from "./ColorEdit.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__